import React from "react";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";
import Select from "react-select";

export default class EssenceReferenceShipEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      editData: {},
      pending: false,
      project: [],
      country: [],
      contractor: [],
      harbor: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.init();
    }
  }

  init = async () => {
    this.setState({ pending: true });
    const editData = this.props.data;
    let project = await this.context.api.qr("/project/list");
    let country = await this.context.api.qr("/country/list");
    let contractor = await this.context.api.qr("/contractor/list");
    let harbor = await this.context.api.qr("/harbor/list");

    this.setState(
      {
        project,
        country,
        contractor,
        editData,
        harbor,
        pending: false,
      },
      () => this.triggerChange()
    );
  };

  getReferenceValue = (value, reference) => {
    if (Array.isArray(reference)) {
      return reference.find((item) => item.value === value) || null;
    }
    return {};
  };

  onChange = (key, value) => {
    this.setState(
      (state) => {
        let editData = state.editData;
        editData[key] = value;
        return { editData };
      },
      () => this.triggerChange()
    );
  };

  triggerChange = () => {
    if (this.props.onChange) {
      this.props.onChange({
        project: this.state.editData.project || null,
        country: this.state.editData.country || null,
        contractor: this.state.editData.contractor || null,
        mmsi: this.state.editData.mmsi || "",
        harbor: this.state.editData.harbor || null,
        callsign: this.state.editData.callsign || "",
      });
    }
  };

  render() {
    const editData = this.state.editData || {};

    return (
      <>
        <Blocker on={this.state.pending}>
          <div className="form-group">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Проект:</label>
                  <Select
                    value={this.getReferenceValue(
                      editData.project,
                      this.state.project
                    )}
                    onChange={(result) =>
                      this.onChange("project", result.value)
                    }
                    className="from-control react-select"
                    classNamePrefix="react-select-inner"
                    options={this.state.project}
                    placeholder="Выберите проект..."
                    noOptionsMessage={({ inputValue }) =>
                      `Ничего не найдено по запросу ${inputValue}`
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Флаг:</label>
                  <Select
                    value={this.getReferenceValue(
                      editData.country,
                      this.state.country
                    )}
                    onChange={(result) =>
                      this.onChange("country", result.value)
                    }
                    className="from-control react-select"
                    classNamePrefix="react-select-inner"
                    options={this.state.country}
                    placeholder="Выберите проект..."
                    noOptionsMessage={({ inputValue }) =>
                      `Ничего не найдено по запросу ${inputValue}`
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Порт приписки:</label>
                  <Select
                    value={this.getReferenceValue(
                      editData.harbor,
                      this.state.harbor
                    )}
                    onChange={(result) => this.onChange("harbor", result.value)}
                    className="from-control react-select"
                    classNamePrefix="react-select-inner"
                    options={this.state.harbor}
                    placeholder="Выберите порт приписки..."
                    noOptionsMessage={({ inputValue }) =>
                      `Ничего не найдено по запросу ${inputValue}`
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Владелец:</label>
                  <Select
                    value={this.getReferenceValue(
                      editData.contractor,
                      this.state.contractor
                    )}
                    onChange={(result) =>
                      this.onChange("contractor", result.value)
                    }
                    className="from-control react-select"
                    classNamePrefix="react-select-inner"
                    options={this.state.contractor}
                    placeholder="Выберите организацию..."
                    noOptionsMessage={({ inputValue }) =>
                      `Ничего не найдено по запросу ${inputValue}`
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>MMSI:</label>
                  <input
                    onChange={(e) => this.onChange("mmsi", e.target.value)}
                    className="form-control"
                    value={editData.mmsi || ""}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Позывной:</label>
                  <input
                    onChange={(e) => this.onChange("callsign", e.target.value)}
                    className="form-control"
                    value={editData.callsign || ""}
                  />
                </div>
              </div>
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
